import { AxiosInstance } from 'axios';
import { TApiResponse } from 'src/@type/common';
import {
  ICheckCourseCanPayBackParams,
  IPayBackCreditPayload,
  CreditReservationsResponse,
  CreditReservationsByStudentResponse,
  ITransferOwnedStudentPayload,
} from './credit.type';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  /** 檢查該課堂是否可以補扣 */
  checkCourseCanPayBack(
    params: ICheckCourseCanPayBackParams,
  ): TApiResponse<boolean> {
    return axios.get(`${apiPrefix}/credit/checkCourseCanPayBack`, { params });
  },

  /** 補扣堂數 */
  payBackCredit(payload: IPayBackCreditPayload): TApiResponse<boolean> {
    return axios.post(`${apiPrefix}/credit/payBackCredit`, payload);
  },
  /**
   * 取得指定帳號下成員預扣堂數資訊。
   * `startAt`／`endAt` 為選填的時間區間，帶入後回傳的預扣堂數只計算該區間內的部分。
   */
  getCreditReservations(
    ocid: string,
    params?: { startAt?: string; endAt?: string },
  ): TApiResponse<CreditReservationsResponse> {
    return axios.get(`${apiPrefix}/credit/reservations/${ocid}/all`, {
      params,
    });
  },
  /** 取得指定帳號下成員預扣堂數資訊 */
  getCreditReservationsByStudent(
    ocid: string,
    studentId: string,
  ): TApiResponse<CreditReservationsByStudentResponse> {
    return axios.get(`${apiPrefix}/credit/reservations/${ocid}/${studentId}`);
  },
  /** 同帳號下學生兼轉移堂數 */
  transferOwnedStudent(
    payload: ITransferOwnedStudentPayload,
  ): TApiResponse<{ isSuccess: boolean }> {
    return axios.post(`${apiPrefix}/credit/transferOwnedStudent`, payload);
  },
});
